import stan from "refractor/stan";
export default stan;